import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import Notiflix from 'notiflix';
import {
  TermContainer,
  WrapperPage,
  TitlePage,
  InfoTerm,
  TextInfoTerm,
  ButtonStyled,
  ContainerBeneficiaryList,
  ContainerPage,
  ContainerUpdateData,
  ContentUpdateData,
  WrapperUpdateData,
  DataTitle,
  DataValue,
} from './styles';
import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';
import api from '../../services/api/api';
import { useAuth } from '../../hooks/auth';
import PageWrapper from '../../components/PageWrapper';
import Modal2 from '../../components/Modal2';
import SelectUnform from '../../components/SelectUnform';

interface TermData {
  term?: string;
  titleTerm?: string;
}

interface BeneficiaryList {
  cardNumber: string;
  reviewRegistration: string;
  userUnimedId: number;
  userUnimedName: string;
}

interface ListDependents {
  content: {
    userUnimedId: number;
    userUnimedName: string;
    cardNumber: string;
    reviewRegistration: string;
  }[];
}

interface BeneficiaryData {
  content: ContentBeneficiaryData;
  message: string;
}

interface ContentBeneficiaryData {
  beneficiaryName: PhisicalPersonCode;
  birthDate: PhisicalPersonCode;
  maritalStatus: PhisicalPersonCode;
  cpf: PhisicalPersonCode;
  cnsNumber: PhisicalPersonCode;
  email: PhisicalPersonCode;
  rg: PhisicalPersonCode;
  emissionDate: PhisicalPersonCode;
  brazilianstatesWhichIssuedRg: PhisicalPersonCode;
  countryRgId: PhisicalPersonCode;
  issuingBody: PhisicalPersonCode;
  foreignRgId: ForeignRgId;
  physicalSex: PhisicalPersonCode;
  birthCityCode: ForeignRgId;
  zipCode: PhisicalPersonCode;
  address: PhisicalPersonCode;
  addressNumber: PhisicalPersonCode;
  complement: PhisicalPersonCode;
  neighborhood: PhisicalPersonCode;
  cityId: PhisicalPersonCode;
  brazilianState: PhisicalPersonCode;
  DDINumber: PhisicalPersonCode;
  DDDNumber: ForeignRgId;
  phone: ForeignRgId;
  DDINumberCellphone: PhisicalPersonCode;
  DDDNumberCellphone: ForeignRgId;
  cellphone: ForeignRgId;
  birthCertificateCodeAlive: ForeignRgId;
  motherName: PhisicalPersonCode;
  fatherName: PhisicalPersonCode;
}

interface ForeignRgId {
  value: null;
  isEditable: boolean;
}

interface PhisicalPersonCode {
  value: string;
  isEditable: boolean;
}

const beneficiaryDataLabels = {
  beneficiaryName: 'Nome Completo',
  birthDate: 'Data de Nascimento',
  maritalStatus: 'Situação Civil',
  cpf: 'CPF',
  cnsNumber: 'CNS',
  email: 'Email',
  rg: 'RG',
  emissionDate: 'Emissão',
  brazilianstatesWhichIssuedRg: 'UF',
  countryRgId: 'País',
  issuingBody: 'Orgão Emissor',
  foreignRgId: 'RG',
  physicalSex: 'Sexo',
  birthCityCode: 'Cidade',
  zipCode: 'CEP',
  address: 'Endereço',
  addressNumber: 'Número',
  complement: 'Complemento',
  neighborhood: 'Bairro',
  cityId: 'Cidade',
  brazilianState: 'Estado',
  DDINumber: 'DDI - Telefone',
  DDDNumber: 'DDD/Telefone',
  phone: 'Telefone',
  DDINumberCellphone: 'DDI - Celular',
  DDDNumberCellphone: 'DDD/Celular',
  cellphone: 'Celular',
  birthCertificateCodeAlive: 'Certidão de Nascimento',
  motherName: 'Nome da Mãe',
  fatherName: 'Nome do Pai',
};

const genderMap = {
  F: 'Feminino',
  M: 'Masculino',
};
const PromptServiceDigital: React.FC = () => {
  const { isAuthendicated, user } = useAuth();
  const formBeneficiaryRef = useRef<FormHandles>(null);
  const [banner, setBanner] = useState<null | string>(null);
  const [term, setTerm] = useState<TermData>({});
  const [magicLink, setMagicLink] = useState<string | null>(null);
  const [beneficiaryList, setBeneficiaryList] = useState<
    [] | Array<BeneficiaryList>
  >([]);
  const [beneficiaryIdData, setBeneficiaryIdData] = useState<null | string>(
    null,
  );
  const [beneficiaryAllData, setBeneficiaryAllData] =
    useState<null | ContentBeneficiaryData>(null);
  const [city, setCity] = useState<null | string>(null);

  const getValueBeneficiary = useCallback(
    (value: string) => {
      if (value === 'physicalSex') {
        return genderMap[
          (beneficiaryAllData as any)[value].value as keyof typeof genderMap
        ];
      }
      if (value === 'cityId') {
        return city || '';
      }
      return (beneficiaryAllData as any)[value].value;
    },
    [beneficiaryAllData, city],
  );
  const getBanner = useCallback(async () => {
    try {
      const response = await api.get(
        `/digital-emergency-care/banner?userUnimedId=${user.id}`,
      );
      setBanner(response.data.banner);
    } catch (error) {
      console.log(error);
    }
  }, [user.id]);
  const getTerm = useCallback(async () => {
    try {
      const response = await api.get<TermData>(
        `/digital-emergency-care/term?userUnimedId=${user.id}`,
      );
      setTerm(response.data);
    } catch (error) {
      Notiflix.Notify.failure('Ops... Falha ao carregar termo.');
      console.log(error);
    }
  }, [user.id]);
  const openTerm = useCallback(() => {
    return Modal2.Generic({
      subtitle: term.titleTerm,
      closable: true,
      children: (
        <>
          {term.term && (
            <TermContainer dangerouslySetInnerHTML={{ __html: term.term }} />
          )}
        </>
      ),
    });
  }, [term]);
  const getBeneficiaryList = useCallback(async () => {
    try {
      const response = await api.get(
        `/digital-emergency-care/beneficiary-list?userUnimedId=${user.id}`,
      );
      setBeneficiaryList(response.data);
    } catch (error) {
      Notiflix.Notify.failure(
        'Ops... Ocorreu um erro ao carregar beneficiários.',
      );
      console.log(error);
    }
  }, [user.id]);
  const sendAcceptTerm = useCallback(async () => {
    try {
      const response = await api.post(`/digital-emergency-care/accept-term`, {
        userUnimedId: String(user.id),
        acceptTerm: 'S',
      });
      if (response.status === 200) {
        Modal2.Close();
        Notiflix.Notify.success('Termo aceito com sucesso.');
        getBeneficiaryList();
      }
    } catch (error) {
      Notiflix.Notify.failure('Erro ao aceitar termo.');
    }
  }, [getBeneficiaryList, user.id]);
  const getMagicLink = useCallback(
    (beneficiaryId: string) => {
      // Abrir nova aba imediatamente no clique
      const newWindow = window.open('', '_blank');

      Notiflix.Notify.info('Solicitando atendimento...');
      Notiflix.Block.circle('.button-get-magic-link');

      api
        .get<{ link: string }>(
          `/digital-emergency-care/magic-link?userUnimedId=${user.id}&consultationUserUnimedId=${beneficiaryId}`,
        )
        .then((response) => {
          if (response.status === 200 && newWindow) {
            newWindow.location.href = response.data.link;
            Notiflix.Notify.success('Atendimento solicitado com sucesso.');
          } else {
            Notiflix.Notify.failure('Não foi possível abrir o atendimento.');
            newWindow?.close();
          }
        })
        .catch(() => {
          Notiflix.Notify.failure('Erro ao solicitar atendimento.');
          newWindow?.close();
        })
        .finally(() => {
          Notiflix.Block.remove('.button-get-magic-link');
          Modal2.Close();
        });
    },
    [user.id],
  );

  const getDataChangeFields = useCallback(
    async (personalCode: string) => {
      try {
        const response = await api.get<BeneficiaryData>(
          `/beneficiary/data-to-change-fields?physicalPersonalCode=${personalCode}&serviceProtocolNumber=${
            user.profile === 1 ? user.serviceProtocolNumber : ''
          }&accessType=B`,
        );
        if (response) {
          api
            .get(
              `/address/list-of-cities?state=${response.data.content.brazilianState.value}`,
            )
            .then((cityResponse) => {
              setCity(
                cityResponse.data.content.find(
                  (i: any) =>
                    i.ibgeCityCode === response.data.content.cityId.value,
                ).city,
              );
            })
            .catch((error) => console.log(error))
            .finally(() => {
              setBeneficiaryAllData(response.data.content);
            });
        }
      } catch (error) {
        Notiflix.Notify.failure(
          'Erro ao carregar informações do beneficiário.',
        );
        console.log(error);
      }
    },
    [user.profile],
  );
  const getBeneficiaryData = useCallback(
    async (id: string) => {
      try {
        const response = await api.get<ListDependents>(
          `/contract/list-holder-and-dependents?userUnimedId=${user.id}`,
        );
        const beneficiaryDependent = response.data.content.find(
          (i) => Number(i.userUnimedId) === Number(id),
        ) as unknown as {
          insuredName: string;
          nrCartao: string;
          phisicalPersonCode: string;
          userUnimedId: number;
        };
        if (beneficiaryDependent) {
          setBeneficiaryIdData(String(beneficiaryDependent.userUnimedId));
          getDataChangeFields(beneficiaryDependent?.phisicalPersonCode);
        } else {
          Notiflix.Notify.failure('Beneficiário não encontrado.');
        }
      } catch (error) {
        Notiflix.Notify.failure('Erro ao carregar beneficiário.');
        console.log(error);
      }
    },
    [getDataChangeFields, user.id],
  );
  const handleSelectBeneficiary = useCallback(
    async (data: { beneficiary: string }) => {
      Notiflix.Block.circle('.button-submit-beneficiary');
      try {
        formBeneficiaryRef.current?.setErrors({});
        const schema = Yup.object().shape({
          beneficiary: Yup.string().required('Beneficiário é obrigatório'),
        });
        await schema.validate(data, {
          abortEarly: false,
        });
        const beneficiaryData = beneficiaryList.find(
          (i) => Number(i.userUnimedId) === Number(data.beneficiary),
        );
        if (beneficiaryData?.reviewRegistration === 'S') {
          getBeneficiaryData(data.beneficiary);
        } else {
          getMagicLink(data.beneficiary);
        }
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formBeneficiaryRef.current?.setErrors(errors);
        }
      }
      Notiflix.Block.remove('.button-submit-beneficiary');
    },
    [beneficiaryList, getBeneficiaryData, getMagicLink],
  );
  useEffect(() => {
    if (isAuthendicated) {
      getBanner();
      getTerm();
    } else {
      Notiflix.Notify.failure('Faça login para acessar');
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);
    }

    if (user.profile === 2) {
      Notiflix.Notify.failure('Faça login como beneficiário para acessar');
      setTimeout(() => {
        window.location.href = '/';
      }, 2000);
    }
  }, [getBanner, getTerm, isAuthendicated, user.profile]);
  useEffect(() => {
    const fetchMagicLink = async () => {
      if (!beneficiaryIdData) return;

      try {
        Notiflix.Block.circle('.button-get-magic-link');
        const response = await api.get<{ link: string }>(
          `/digital-emergency-care/magic-link?userUnimedId=${user.id}&consultationUserUnimedId=${beneficiaryIdData}`,
        );

        if (response.status === 200) {
          setMagicLink(response.data.link);
        } else {
          Notiflix.Notify.failure('Erro ao buscar link de atendimento.');
        }
      } catch (error) {
        Notiflix.Notify.failure('Erro ao solicitar atendimento.');
      } finally {
        Notiflix.Block.remove('.button-get-magic-link');
      }
    };

    fetchMagicLink();
  }, [beneficiaryIdData, user.id]);

  useEffect(() => {
    if (beneficiaryAllData) {
      Modal2.Warning({
        adjustWidth: true,
        closable: true,
        children: (
          <ContainerUpdateData>
            <ContentUpdateData>
              {Object.keys(beneficiaryAllData as ContentBeneficiaryData)
                .filter(
                  (key) =>
                    key !== 'phisicalPersonCode' &&
                    key !== 'maritalStatus' &&
                    key !== 'countryRgId' &&
                    key !== 'issuingBody' &&
                    key !== 'foreignRgId' &&
                    key !== 'rg' &&
                    key !== 'emissionDate' &&
                    key !== 'birthCertificateCodeAlive' &&
                    key !== 'cnsNumber' &&
                    key !== 'birthCityCode' &&
                    key !== 'brazilianstatesWhichIssuedRg',
                )
                .map((value) => (
                  <WrapperUpdateData key={value}>
                    <DataTitle>
                      {
                        beneficiaryDataLabels[
                          value as keyof typeof beneficiaryDataLabels
                        ]
                      }
                      :
                    </DataTitle>
                    <DataValue>{getValueBeneficiary(value)}</DataValue>
                  </WrapperUpdateData>
                ))}
            </ContentUpdateData>
            <Button
              orangeButton
              onClick={() => {
                window.location.href = `/alterar-dados-cadastrais?pa-digital=true&beneficiaryId=${beneficiaryIdData}`;
                Modal2.Close();
              }}
            >
              Atualizar meus dados
            </Button>
            <a
              href={magicLink ?? '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="button-get-magic-link"
              style={{ textDecoration: 'none', width: '100%' }}
            >
              <Button
                greenButton
                disabled={!magicLink}
                style={{
                  width: '100%',
                }}
                className="button-get-magic-link"
              >
                Confirmar e Acessar
              </Button>
            </a>
          </ContainerUpdateData>
        ),
      });
    }
  }, [
    beneficiaryAllData,
    beneficiaryIdData,
    getMagicLink,
    getValueBeneficiary,
    magicLink,
  ]);

  return (
    <>
      {isAuthendicated && user.profile === 1 && (
        <PageWrapper gridTemplateColumns="1fr">
          <WrapperPage>
            <ContainerPage>
              {banner && (
                <div
                  dangerouslySetInnerHTML={{ __html: banner }}
                  className="banner-container"
                />
              )}
              {term && !beneficiaryList.length && (
                <>
                  <TitlePage>Termo de Atendimento P.A. Digital</TitlePage>
                  <TextInfoTerm>
                    Para acessar o Pronto Atendimento Digital, aceite o
                    <InfoTerm onClick={() => openTerm()}>
                      Termo de Compartilhamento de Dados
                    </InfoTerm>
                  </TextInfoTerm>
                  <div className="buttons-container">
                    <ButtonStyled
                      onClick={() => {
                        window.location.href = '/';
                      }}
                      secondary
                    >
                      Cancelar
                    </ButtonStyled>
                    <Button
                      className="button-accept-terms"
                      onClick={sendAcceptTerm}
                    >
                      Aceitar Termo
                    </Button>
                  </div>
                </>
              )}
              {beneficiaryList.length > 0 && (
                <ContainerBeneficiaryList>
                  <Form
                    ref={formBeneficiaryRef}
                    onSubmit={handleSelectBeneficiary}
                  >
                    <TitlePage>Selecione o beneficiário</TitlePage>
                    <SelectUnform
                      name="beneficiary"
                      options={beneficiaryList.map((i) => ({
                        name: i.userUnimedName,
                        id: String(i.userUnimedId),
                      }))}
                    />
                    <Button type="submit" className="button-submit-beneficiary">
                      Acessar
                    </Button>
                  </Form>
                </ContainerBeneficiaryList>
              )}
            </ContainerPage>
          </WrapperPage>
        </PageWrapper>
      )}
    </>
  );
};

export default PromptServiceDigital;
